const getWholesaleDiscountCode = () => {
    let wholesaleDataElem = document.getElementById('wholesaleDiscountData');

    if (wholesaleDataElem) {
        let wholesaleData = JSON.parse(wholesaleDataElem.innerHTML);
        let button = document.querySelector(".cart__checkout-button");
        button.disabled = true;

        let original = wholesaleData.original / Shopify.currency.rate;
        let final = wholesaleData.final / Shopify.currency.rate;
        let discount = original - final;

        if (discount > 0) {
            fetch(`/apps/wholesalecoupon?amount=${discount / 100}&total=${final / 100}`)
                .then(r => r.json())
                .then(j => {
                    let input = document.querySelector('input.wholesale-discount-code');
                    input.value = j.code;
                    document.cookie = `discount_code=${j.code}`;
                    button.disabled = false;
                    let notice = document.querySelector('.wholesale-discount__notice');
                    notice.style.display = 'block';
                    let span = document.querySelector('.wholesale-discount__code');
                    span.innerText = j.code;
                });
        }
        else button.disabled = false;	
    }
}

getWholesaleDiscountCode();